import React, { useContext, useEffect, useState } from 'react';
import Link from 'next/link';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { IStaticPageProps } from '../models/Contentful/types';
import Cookie from '../components/Cookie';
import styles from '../components/AnnouncementBar/announcementBar.module.sass';
import contentfulClient from '../models/Contentful';
import { ContentfulEntry } from '../blades/widgetTypes';
import { IContentfulInformativeModal } from '../blades/informativeModal/@types';
import { logger } from '../utils';
import AuthContext from '../AppContext/AuthProvider';

export interface MainLayoutProps extends IStaticPageProps<unknown> {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, site }) => {
  const [path, setPath] = useState<string>();
  const { appUser } = useContext(AuthContext);
  const [announcement, setAnnouncement] = useState<any>();
  const getAnnouncement = async (role: string) => {
    try {
      const response = await contentfulClient.getEntries<
        ContentfulEntry<IContentfulInformativeModal>
      >({
        content_type: 'announcement',
      });
      const { items } = response;
      const roleAnnounce: any = items.find((item: any) => item.fields.type === role);
      const allUsersAnnounce: any = items.find((item: any) => item.fields.type === 'All Users');
      const now = new Date();
      let announcement: any;
      if (
        now >= new Date(allUsersAnnounce?.fields.startDate) &&
        now < new Date(allUsersAnnounce?.fields.endDate)
      ) {
        announcement = allUsersAnnounce.fields;
      }
      if (
        now >= new Date(roleAnnounce?.fields.startDate) &&
        now < new Date(roleAnnounce?.fields.endDate)
      ) {
        announcement = roleAnnounce.fields;
      }
      if (announcement) {
        setAnnouncement(announcement);
      }
      return response;
    } catch (error) {
      logger.error(error);
      return null;
    }
  };
  useEffect(() => {
    // get Announcement Bar
    if (appUser) {
      getAnnouncement(appUser.role);
    }
    const pathLocation = window.location.pathname;
    setPath(pathLocation);
    if (pathLocation !== '/sign-up/') {
      localStorage.removeItem('role');
    }
  }, [appUser]);
  if (path === '/sign-up/' || path === '/log-in/') {
    return (
      <>
        <Header {...site.header} />
        <div className="body">{children}</div>
      </>
    );
  }
  return (
    <>
      {announcement && (
        <div
          className={styles.announcementBar}
          style={{ backgroundColor: announcement.backgroundColor, color: announcement.textColor }}
        >
          <p>
            {announcement.text}{' '}
            {announcement.linkUrl && (
              <Link className={styles.announcementLink} href={announcement.linkUrl}>
                {announcement.linkText}
              </Link>
            )}
          </p>
        </div>
      )}
      <Header {...site.header} />
      <div className="body">{children}</div>
      <Footer {...site.footer} />
      <Cookie />
    </>
  );
};

export default MainLayout;
